import type { ButtonHTMLAttributes } from 'react';
import { Icon } from '../../../lib/icon/Icon';
import { cn } from '../../../lib/utils';
import { Button } from '../button';

interface BackButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

function BackButton({ children, className, ...props }: BackButtonProps) {
  return (
    <Button
      size="sm"
      className={cn(
        'gap-1 rounded-full bg-border-subtle py-1 pr-3 pl-1 font-body text-foreground hover:bg-gray-300 active:bg-gray-400',
        className,
      )}
      {...props}
    >
      <Icon name="arrow-left" size="lg" />
      {children}
    </Button>
  );
}

export type { BackButtonProps };
export { BackButton };
